module.exports = __webpack_public_path__ + "static/media/delete.08bbb04a.svg";